import React, { useEffect, useContext, useState } from 'react';
import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png";
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';
import { aboutCompany, accountAggregator } from '../../../Utils/api';
import { useNavigate } from 'react-router-dom';
import { formateDate, getStorage, goBack, isEmpty, setStorage } from '../../../Utils/common';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { formValidation } from '../../../Utils/formValidation';
import RadioButtons from '../../../components/ui/RadioButtons';
import ContextDashboard from '../../../Context/ContextDashboard';
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import { Landmark } from "lucide-react";

const initialData = {
    name: "",
    acc1: "",
    branch: "",
    ifsc: "",
    acc2: "",
};



function BankDetail() {
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState({});
    const [formData, setFormData] = useState(initialData);
    const [formDataError, setFormDataError] = useState(initialData);
    const [progressBar, setProgressBar] = useState(getStorage("percent"));
    const [showSteps, setShowSteps] = useState(-1);
    const [toggle, setToggle] = useState(true);
    const navigate = useNavigate();
    const { message, setMessage, logout, handleEvent } = useContext(ContextDashboard);
    // Bank accounts the customer shared through Account Aggregator (prefill).
    const [aaAccounts, setAaAccounts] = useState([]);
    const [aaSelected, setAaSelected] = useState(null);

    const applyAaAccount = (account) => {
        setAaSelected(account);
        if (!account) {
            return;
        }
        setFormData((current) => ({
            ...current,
            name: account.holder_name || current.name,
            branch: account.branch || current.branch,
            ifsc: account.ifsc || current.ifsc,
        }));
        setFormDataError((current) => ({ ...current, name: "", branch: "", ifsc: "" }));
    };

    useEffect(() => {
        accountAggregator({
            profile_id: getStorage("cust_profile_id") || "",
            event_name: "account_aggregator_bank_details",
        }).then((resp) => {
            const accounts = resp?.data?.Status === 1 ? (resp?.data?.Data?.accounts || []) : [];
            if (accounts.length > 0) {
                setAaAccounts(accounts);
                applyAaAccount(accounts[0]); // salary account first
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const submit = () => {
        const error = formValidation(formData);

        // Check if Account Number and Confirm Account Number match
        if (formData.acc1 !== formData.acc2) {
            error.acc2 = "Account numbers do not match"; // Set error if they don't match
        }

        // AA only shares the last 4 digits; the typed number must belong to the chosen account.
        if (aaSelected && aaSelected.last4 && formData.acc1 && !formData.acc1.trim().endsWith(aaSelected.last4)) {
            error.acc1 = `This doesn't match your ${aaSelected.bank_name || "bank"} account ending ${aaSelected.last4}`;
        }

        setFormDataError({ ...formDataError, ...error });

        const param = {
            profile_id: getStorage("cust_profile_id") || "",
            event_name: "banking_details",
            account_branch: formData.branch,
            account_ifsc: formData.ifsc,
            account_number: formData.acc1,
            confirm_account_number: formData.acc2,
            account_name: formData.name,
            account_type_id: 1,
            verification_consent: 1
        };

        if (formData.maritalStatus !== "2") {
            delete error.spouseName;
        }

        if (isEmpty(error)) {
            setLoading(true);
            aboutCompany(param).then(resp => {
                setLoading(false);
                if (resp?.data?.Status === 1) {
                    setResponse(resp?.data);
                    setStorage("next_step", resp?.data?.Data?.next_step)
                    setStorage('percent', resp?.data?.Data?.step_percentage)
                    setMessage({ type: 'success', msg: resp?.data?.Message, place: "global" });
                    handleEvent(getStorage('next_step'));
                } else if (resp?.data?.Status === 4) {
                    logout();
                } else {
                    setMessage({ type: 'error', msg: resp?.data?.Message });
                }
            });
        }
    };

    const onChange = (e) => {
        let { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (formDataError[name]) {
            setFormDataError({ ...formDataError, [name]: "" });
        }
    };

    return (
        <>
            {/* <BoxWrapper className="w100">
                <div className="formmainBox flex">
                    <div className="left">
                       
                    </div>
                    <div className="right">
                        <h2 style={{ color: '#1D3557' }}>Banking Details *</h2>
                        <p style={{ color: '#1D3557' }}>Share your bank details.</p>
                        <FormWrapper>
                            <Alert setMessage={setMessage} message={message} />
                            <div className="inputBox">
                                <Input
                                    label="Name(as per Bank Account)"
                                    name="name"
                                    error={formDataError?.name}
                                    onChange={onChange}
                                    value={formData?.name}
                                    required={true}
                                />
                                <Input
                                    label="Branch Name"
                                    name="branch"
                                    error={formDataError?.branch}
                                    onChange={onChange}
                                    value={formData?.branch}
                                    required={true}
                                />
                                <Input
                                    label="Account Number"
                                    name="acc1"
                                    error={formDataError?.acc1}
                                    onChange={onChange}
                                    value={formData?.acc1}
                                    required={true}
                                />

                                <Input
                                    label="Confirm Account Number"
                                    name="acc2"
                                    error={formDataError?.acc2}
                                    onChange={onChange}
                                    value={formData.acc2}
                                    required={true}
                                    onPaste={(e) => e.preventDefault()}
                                />

                                <Input
                                    label="IFSC Code"
                                    name="ifsc"
                                    error={formDataError?.ifsc}
                                    onChange={onChange}
                                    value={formData.ifsc}
                                    required={true}
                                />
                            </div>
                            <div className="button">
                                <Button className="bg-[#2D5F7A]" title="Continue" onClick={submit} loading={loading} />
                            </div>
                        </FormWrapper>
                    </div>
                </div>
            </BoxWrapper> */}


            <BoxWrapper className="w-full min-h-screen bg-gray-100 p-3 sm:p-5 md:p-8">

                <div className="flex flex-col gap-5">

                    {/* Card */}
                    <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-5 sm:p-8 md:p-10">

                        {/* Header */}
                        <div className="text-center mb-8">

                            <div className="flex justify-center mb-5">
                                <div className="flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-2xl bg-[#EEF6FF] border border-blue-100 shadow-sm">
                                    <Landmark className="h-8 w-8 sm:h-10 sm:w-10 text-[#2D5F7A]" />
                                </div>
                            </div>

                            <h2 className="text-2xl sm:text-3xl font-bold text-[#1D3557]">
                                Banking Details <span className="text-red-500">*</span>
                            </h2>

                            <p className="mt-2 text-sm sm:text-base text-gray-500">
                                Share your bank details.
                            </p>

                        </div>

                        <FormWrapper>

                            <Alert
                                setMessage={setMessage}
                                message={message}
                            />

                            {aaAccounts.length > 0 && (
                                <div className="mb-6 rounded-2xl border border-blue-200 bg-blue-50 p-4 sm:p-5">
                                    <h4 className="font-semibold text-[#1D3557]">
                                        Accounts shared through Account Aggregator
                                    </h4>
                                    <p className="mt-1 text-sm text-gray-600">
                                        Pick the account for your loan. We've filled in the details; enter the full account number to confirm it.
                                    </p>
                                    <div className="mt-4 flex flex-col gap-2">
                                        {aaAccounts.map((account) => {
                                            const active = aaSelected && aaSelected.masked_account === account.masked_account && aaSelected.bank_name === account.bank_name;
                                            return (
                                                <label
                                                    key={`${account.bank_name}-${account.masked_account}`}
                                                    className={`flex items-center gap-3 rounded-xl border bg-white px-4 py-3 cursor-pointer ${active ? "border-[#2D5F7A] ring-1 ring-[#2D5F7A]" : "border-gray-200"}`}
                                                >
                                                    <input type="radio" name="aa_account" checked={!!active} onChange={() => applyAaAccount(account)} />
                                                    <span className="flex-1 text-sm sm:text-base text-[#1D3557]">
                                                        {account.bank_name} •••• {account.last4}
                                                        <span className="text-gray-500"> · {account.account_type ? account.account_type.toLowerCase() : "account"}</span>
                                                    </span>
                                                    {account.salary_account === 1 && (
                                                        <span className="text-xs font-medium text-green-700 bg-green-100 rounded-full px-2 py-0.5">Salary account</span>
                                                    )}
                                                </label>
                                            );
                                        })}
                                        <label className={`flex items-center gap-3 rounded-xl border bg-white px-4 py-3 cursor-pointer ${!aaSelected ? "border-[#2D5F7A] ring-1 ring-[#2D5F7A]" : "border-gray-200"}`}>
                                            <input type="radio" name="aa_account" checked={!aaSelected} onChange={() => applyAaAccount(null)} />
                                            <span className="text-sm sm:text-base text-[#1D3557]">Use a different account</span>
                                        </label>
                                    </div>
                                </div>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                                <Input
                                    label="Name(as per Bank Account)"
                                    name="name"
                                    error={formDataError?.name}
                                    onChange={onChange}
                                    value={formData?.name}
                                    required={true}
                                />

                                <Input
                                    label="Branch Name"
                                    name="branch"
                                    error={formDataError?.branch}
                                    onChange={onChange}
                                    value={formData?.branch}
                                    required={true}
                                />

                                <Input
                                    label={aaSelected?.last4 ? `Account Number (ending ${aaSelected.last4})` : "Account Number"}
                                    name="acc1"
                                    error={formDataError?.acc1}
                                    onChange={onChange}
                                    value={formData?.acc1}
                                    required={true}
                                />

                                <Input
                                    label="Confirm Account Number"
                                    name="acc2"
                                    error={formDataError?.acc2}
                                    onChange={onChange}
                                    value={formData.acc2}
                                    required={true}
                                    onPaste={(e) => e.preventDefault()}
                                />

                                <div className="md:col-span-2">
                                    <Input
                                        label="IFSC Code"
                                        name="ifsc"
                                        error={formDataError?.ifsc}
                                        onChange={onChange}
                                        value={formData.ifsc}
                                        required={true}
                                    />
                                </div>

                            </div>

                            {/* Security Card */}

                            <div className="mt-8 flex gap-4 rounded-2xl border border-green-200 bg-green-50 p-5">

                                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow shrink-0">
                                    🔒
                                </div>

                                <div>
                                    <h4 className="font-semibold text-[#1D3557]">
                                        Your banking information is secure
                                    </h4>

                                    <p className="mt-1 text-sm text-gray-600">
                                        Your account details are encrypted and used only for verification and loan disbursement.
                                    </p>
                                </div>

                            </div>

                            <div className="mt-8">
                                <Button
                                    className="w-full bg-[#2D5F7A]"
                                    title="Continue"
                                    onClick={submit}
                                    loading={loading}
                                />
                            </div>

                        </FormWrapper>

                    </div>

                </div>

            </BoxWrapper>
        </>
    );
}

export default BankDetail;